import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import usePendingUndo from './usePendingUndo';
import { sendNow, undoMove } from './actions';

const Toast = styled.div`
  position: absolute;
  left: 50%;
  bottom: 12px;
  z-index: 30;
  transform: translateX(-50%);
  width: min(92%, 420px);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 10px 10px 14px;
  border-radius: 14px;
  background: rgba(14, 22, 18, .94);
  box-shadow: 0 10px 28px rgba(0, 0, 0, .5);
  color: #f4f1e8;
  font-size: 14px;
  line-height: 1.3;

  & strong {
    display: block;
    font-size: 12px;
    letter-spacing: .05em;
    text-transform: uppercase;
    color: #ffcb05;
  }
`;

const Buttons = styled.div`
  flex: none;
  margin-left: auto;
  display: flex;
  gap: 8px;
`;

/** Sends it now: for when you're sure. */
const GoButton = styled.button`
  min-width: 64px;
  height: 44px;
  border: 0;
  border-radius: 11px;
  background: rgba(255, 255, 255, .12);
  color: #f4f1e8;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
`;

const UndoButton = styled.button`
  min-width: 84px;
  height: 44px;
  border: 0;
  border-radius: 11px;
  background: #ffcb05;
  color: #1b1b1b;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
`;

/**
 * A move waiting for its Undo (a retreat, Switch), on the board itself where you're looking as you make it: what it
 * will do, counting down, a big Undo, and Go to send it now when you're sure.
 */
const UndoToast = () => {
  const dispatch = useDispatch();
  const pending = usePendingUndo();
  if (!pending) {
    return null;
  }
  return (
    <Toast role="status">
      <div><strong>{pending.title}</strong>{pending.hint}</div>
      <Buttons>
        <GoButton onClick={() => dispatch(sendNow())} aria-label="Go now">Go</GoButton>
        <UndoButton onClick={() => dispatch(undoMove())}>Undo</UndoButton>
      </Buttons>
    </Toast>
  );
};

export default UndoToast;
